module.exports = __webpack_public_path__ + "img/金林豪生2.2b2be40f.jpg";